import { BrushElementModel, ConnectorElementModel, GroupElementModel, ShapeElementModel, TextElementModel } from '@blocksuite/affine-model';

import { AttachmentChipElementModel } from './attachment-chip.js';
import { SurfaceElementModel } from './base.js';
import { BubbleCollectionElementModel } from './collection-bubble.js';
import { MindmapElementModel } from './mindmap.js';
import { MindmapHighlightElementModel } from './mindmap-highlight.js';
import { getCustomElementsCtorMap } from './registry.js';

export const elementsCtorMap = {
  group: GroupElementModel,
  connector: ConnectorElementModel,
  shape: ShapeElementModel,
  brush: BrushElementModel,
  text: TextElementModel,
  mindmap: MindmapElementModel,
  'collection-bubble': BubbleCollectionElementModel,
  'attachment-chip': AttachmentChipElementModel,
  'mindmap-highlight': MindmapHighlightElementModel,
  ...getCustomElementsCtorMap(),
};

export {
  BrushElementModel,
  ConnectorElementModel,
  GroupElementModel,
  MindmapElementModel,
  ShapeElementModel,
  SurfaceElementModel,
  TextElementModel,
};

export enum CanvasElementType {
  BRUSH = 'brush',
  CONNECTOR = 'connector',
  GROUP = 'group',
  MINDMAP = 'mindmap',
  SHAPE = 'shape',
  TEXT = 'text',
}

export type ElementModelMap = {
  ['shape']: ShapeElementModel;
  ['brush']: BrushElementModel;
  ['connector']: ConnectorElementModel;
  ['text']: TextElementModel;
  ['group']: GroupElementModel;
  ['mindmap']: MindmapElementModel;
  ['collection-bubble']: BubbleCollectionElementModel;
  ['attachment-chip']: AttachmentChipElementModel;
  ['mindmap-highlight']: MindmapHighlightElementModel;
};

export function isCanvasElementType(type: string): type is CanvasElementType {
  return type.toLocaleUpperCase() in CanvasElementType;
}
